<div class="form-input" [class.disabled]="disabled">
  <!-- Label appears only when search flag false -->
  <label *ngIf="!search && label" class="input-label">{{ label }}</label>
  <div class="input-wrapper">
    <div class="input-container">
      <span *ngIf="search" class="icon left material-symbols-outlined" aria-hidden="true"
        >search</span
      >
      <input
        type="text"
        class="input-field"
        [attr.placeholder]="placeholder || (search ? 'Search' : null)"
        [disabled]="disabled"
        [value]="value"
        (input)="onInput($event)"
      />
    </div>
    <button
      *ngIf="datePicker"
      type="button"
      class="icon-button date-button"
      [disabled]="disabled"
      aria-label="Open date picker"
    >
      <span class="material-symbols-outlined" aria-hidden="true">calendar_month</span>
    </button>
  </div>
</div>
